import {Link} from 'react-router-dom'
import {useEffect, useState} from 'react'
import { collection, query, where, getDocs, DocumentData, getFirestore, limit } from "firebase/firestore";
import app from "../firebaseapp"
import "../css/course.css"
function Category() {
const db = getFirestore(app)
    let [slug, setSlug] = useState("")
    let [load, setLoad] = useState(false)
    let [posts, setPosts] = useState<any[]>([])
    let [listItems, setListItems] = useState<any[]>([])
    let [domain, setDomain] = useState("localhost")
    let [lang, setLang] = useState("en")

    useEffect(() => {

//get domain

let domainS = window.location.hostname;
console.log(domainS)
let postsS = "sentiment_analysis"




//end getDomain


        let currentpathName = window.location.pathname;
        console.log("pathname: "+ currentpathName)
        // /category/1
        slug = currentpathName.substring(10, currentpathName.lastIndexOf("/"))
        console.log(slug)
        setSlug(slug)
        const getPosts = async () => {

            const q = query(collection(db, postsS),limit(9));
            posts = []
            setPosts(posts)
            listItems = []
            setListItems(listItems)
            const querySnapshot = await getDocs(q);
            // querySnapshot.forEach((doc) => {
            //   let theDoc:DocumentData = doc.data()
            //   // doc.data() is never undefined for query doc snapshots
            //   console.log(doc.id, " => ", doc.data());
            //   theDoc.id = doc.id
            //   theDoc.slug = doc.id
            //   posts.push(theDoc)
            //   setPosts(posts)



              

            // });
            setPosts(querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));

            return posts


      
            

                    }
        if (!load){
            getPosts()
load = true
setLoad(load)
        }else{
          console.log("loaded")
        }
      


       

    

    }, [])

      
function setLangPage(lang: string){
  console.log("eur")
  if (lang == "es"){
    window.location.replace("/courses/es/")
  }else if (lang == "en"){
    //window.location.replace("/courses/")
  }

}
  

    return (
      <>
       <div>
<h1 className='title'>Category: Indicators</h1>
<p>Check our News Feeds with our unique analysis</p>
<select onChange={(e)=> {setLang(e.target.value); setLangPage(e.target.value);}} id="lang" name="lang">
  <option value="en">English</option>
  </select>

<p>**All our Indicators are Free</p>
<ul> 
  {/*<div><a href={"/p/"+d.id+"/" } key={d.id}> <li >{d.title}</li></a><br /></div>*/}
  <div className='grid-container-3'>
        {posts.map(
          d => (
            <div className="grid-item"><div className="card">
              <a href={"/sentiment_analysis/indicator/"+d.id+"/" }>
                <img className="imgCourse" src={d.image} alt="Avatar" />
            <div className="container title_course"><div className="topContainer">
              <span className="students">Top News, Trends <b><del>    </del>  Business Intelligence</b></span><span className="time">  </span></div>
              <h4>{d.title}<b></b></h4><p>Early Access</p></div></a></div></div>
          ))} 
          </div> 
                </ul>
            



       </div>
      
       
      </>
    );
  }
  export default Category;